module.exports = __webpack_public_path__ + "img/jenkins.990f7a3d.png";